import { LanguageService } from '$core/services/language.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  public languageService: LanguageService;

  constructor(private injector: Injector) {
    this.languageService = this.injector.get(LanguageService);
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers = req.headers
      .set('hl', this.languageService.currentLang || '')
      .set('Accept', 'application/json')
      .set('platform', 'web');

    const cloneReq = req.clone({ headers });
    return next.handle(cloneReq);
  }
}
